import { useState, useEffect } from 'react';
import { Card } from '@/components/ui/card';

const CounterCard = ({ end, duration = 2000, label, color = "text-primary" }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime;
    let animationFrame;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = (currentTime - startTime) / duration;

      if (progress < 1) {
        setCount(Math.floor(end * progress));
        animationFrame = requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [end, duration]);

  const formatNumber = (num) => {
    return num.toLocaleString();
  };

  return (
    <Card className="p-6 bg-white/80 backdrop-blur-sm border border-border card-shadow-lg hover:shadow-xl transition-all">
      <div className={`text-3xl md:text-4xl font-bold ${color} mb-2`}>
        {label.includes('Rating') ? (count / 1000).toFixed(1) : formatNumber(count)}
        {label.includes('Rating') && '/5'}
      </div>
      <div className="text-sm text-muted-foreground font-medium">{label}</div>
    </Card>
  );
};

export default CounterCard;
